import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ProfileHeaderComponent } from '../profile-header/profile-header.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { PageFooterComponent } from '../page-footer/page-footer.component';
import { StickyBarComponent } from '../sticky-bar/sticky-bar.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, ProfileHeaderComponent, NavBarComponent, PageFooterComponent, StickyBarComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent {}
